<template>
  <svg :width="width" :height="width">
    <use
      :xlink:href="require('@/assets/svg/material-symbols.svg') + `#${name}`"
    ></use>
  </svg>
</template>
<script>
export default {
  name: 'MaterialSvg',
  props: {
    name: {
      type: String,
      required: true,
    },
    width: {
      type: [Number, String],
      default: 24,
    },
  },
};
</script>

<style scoped lang="scss">
.icon-white {
  fill: $white;
}
.icon-cyaan {
  fill: $primary-color;
}
.icon-red {
  fill: $error;
}
</style>